<template>
    <v-container fluid>
        <v-row v-show="populating == false && populatingFailure == false">
            <v-col
                cols="12"
                md="6"
            >
                <v-row>
                    <v-col cols="12">
                        <v-card>
                            <v-form
                                ref="dayBatchForm"
                                v-model="isValid"
                            >
                                <v-card-text>
                                    <v-container
                                        class="pa-0"
                                        fluid
                                    >
                                        <v-row class="pb-0">
                                            <v-col
                                                :key="index"
                                                class="pt-0 pb-4"
                                                cols="12"
                                                v-for="(claim,
                                        index) in dayBatch.claims"
                                            >
                                                <v-card>
                                                    <v-card-title class="pb-0">
                                                        Claim #{{ claim.id }}
                                                        <v-spacer></v-spacer>
                                                        <v-btn
                                                            @click.stop="
                                                        getFile(
                                                            claim.claimBatchFileId, 'claim' +claim.id.toString() + '_batchfile' +claim.claimBatchFileId.toString()
                                                        )
                                                    "
                                                            elevation="1"
                                                            fab
                                                            small
                                                        >
                                                            <h3>
                                                                <v-icon color="light-blue">mdi-download</v-icon>
                                                            </h3>
                                                        </v-btn>
                                                    </v-card-title>
                                                    <v-card-text>
                                                        <v-switch
                                                            :disabled="isLoading"
                                                            @change="
                                                        setClaimPrintedVerified(
                                                            claim
                                                        )
                                                    "
                                                            class="mb-0"
                                                            label="Printed and Verified"
                                                            v-model="
                                                        claim.printedVerified
                                                    "
                                                        ></v-switch>
                                                    </v-card-text>
                                                </v-card>
                                            </v-col>
                                            <v-col
                                                cols="12"
                                                v-if="!(dayBatch.coverFileId > 0)"
                                            >
                                                <v-btn
                                                    :disabled="isLoading"
                                                    :loading="isGeneratingCoverPage"
                                                    @click="generateCoverPage"
                                                    class="text-none"
                                                    color="secondary darken-1"
                                                >Generate Cover Page</v-btn>
                                            </v-col>
                                            <v-col
                                                class="pt-0"
                                                cols="12"
                                                v-if="dayBatch.coverFileId > 0"
                                            >
                                                <v-card>
                                                    <v-card-title class="pb-0">
                                                        Cover Page File #{{
                                                        dayBatch.coverFileId
                                                        }}
                                                        <v-spacer></v-spacer>
                                                        <v-btn
                                                            @click.stop="
                                                        getFile(
                                                            dayBatch.coverFileId,
                                                            'Cover' +
                                                                dayBatch.dayBatchNumber
                                                        )
                                                    "
                                                            elevation="1"
                                                            fab
                                                            small
                                                        >
                                                            <h3>
                                                                <v-icon color="light-blue">mdi-download</v-icon>
                                                            </h3>
                                                        </v-btn>
                                                    </v-card-title>
                                                    <v-card-text>
                                                        <v-switch
                                                            :disabled="isLoading"
                                                            @change="
                                                        setCoverPrintedVerified
                                                    "
                                                            class="mb-0"
                                                            label="Printed and Verified"
                                                            v-model="
                                                        dayBatch.coverPrintedVerified
                                                    "
                                                        ></v-switch>
                                                    </v-card-text>
                                                </v-card>
                                            </v-col>
                                            <v-col cols="12">
                                                <v-btn
                                                    :disabled="isLoading || !canProcess"
                                                    :loading="isProcessing"
                                                    @click="processDayBatch"
                                                    class="text-none"
                                                    color="secondary darken-1"
                                                >Process</v-btn>
                                            </v-col>
                                        </v-row>
                                        <v-row
                                            align="end"
                                            class="pt-5"
                                            justify="space-between"
                                            no-gutters
                                        >
                                            <v-btn
                                                :disabled="isLoading && !isDeleting"
                                                :loading="isDeleting"
                                                @click="deleteEntity"
                                                class="text-none"
                                                color="warning darken-1"
                                                text
                                                v-show="dayBatch.id > 0"
                                            >Delete</v-btn>
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                :disabled="isLoading"
                                                @click="closeForm"
                                                class="text-none"
                                                color="secondary darken-1"
                                                text
                                            >Close</v-btn>
                                            <!-- <v-btn
                                        :disabled="isLoading && !isProcessing"
                                        :loading="isProcessing"
                                        @click="processDayBatch"
                                        class="text-none"
                                        color="secondary darken-1"
                                        text
                                        >Update</v-btn
                                            >-->
                                        </v-row>
                                    </v-container>
                                </v-card-text>
                            </v-form>
                            <v-snackbar
                                :color="notifyColor"
                                :timeout="15000"
                                top
                                v-model="notifyShow"
                            >
                                {{ notifyMessage }}
                                <template v-slot:action="{ attrs }">
                                    <v-btn
                                        @click="notifyShow = false"
                                        class="text-none"
                                        icon
                                        v-bind="attrs"
                                    >
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                </template>
                            </v-snackbar>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
            <v-col
                cols="12"
                md="6"
            ></v-col>
        </v-row>
        <v-row v-show="populating == true">
            <v-col
                class="text-center"
                cols="12"
            >
                <v-progress-circular
                    :size="50"
                    color="secondary"
                    indeterminate
                ></v-progress-circular>
            </v-col>
        </v-row>
        <v-row v-show="populating == false && populatingFailure == true">
            <v-col
                class="text-center"
                cols="12"
            >Could not load the form. Please refresh the page and try again. If the issue persists contact support.</v-col>
        </v-row>
    </v-container>
</template>

<script>
import uuid4 from "../../helpers/uuid4";
export default {
    props: {
        dayBatchIn: Number,
        dayBatchNumber: String
    },
    created: async function() {
        //
    },
    components: {
        //
    },
    data() {
        return {
            populating: true,
            populatingFailure: true,
            dayBatch: {}, //new DayBatch(), // new DayBatch().set(this.dayBatchIn),
            returnedCoverDocument: null,
            isValid: null,
            isLoading: null,
            isSaving: null,
            isDeleting: null,
            isProcessing: null,
            isGeneratingCoverPage: null,
            notifyShow: null,
            notifyMessage: null,
            notifyColor: null,
            requestId: uuid4(),

            reloadKey: 0
        };
    },
    mounted: async function() {
        await this.loadDayBatch();
    },
    computed: {
        canProcess: function() {
            return (
                this.dayBatch.coverPrintedVerified &&
                this.dayBatch.claims.every(x => x.printedVerified)
            );
        }
    },
    methods: {
        async loadDayBatch() {
            if (
                this.dayBatchIn > 0 &&
                this.dayBatchNumber != null &&
                this.dayBatchNumber != ""
            ) {
                var requestId = (this.requestId = uuid4());
                var dayBatchesResponse = await this.$store.dispatch(
                    "dayBatches/getDayBatchPostSubmissionFormDto",
                    {
                        id: this.dayBatchIn,
                        requestId: requestId
                    }
                );
                if (
                    this.requestId == dayBatchesResponse.requestId &&
                    dayBatchesResponse.data != null &&
                    dayBatchesResponse.data.dayBatchNumber ==
                        this.dayBatchNumber &&
                    dayBatchesResponse.data.id == this.dayBatchIn
                ) {
                    this.dayBatch = dayBatchesResponse.data;
                    this.reloadKey += 1000;

                    this.populatingFailure = false;
                }
            }
            this.populating = false;
        },
        getFile(fileId, namePrefix) {
            this.$store.dispatch("files/get", {
                fileId: fileId,
                namePrefix: namePrefix
            });
        },
        //claim printed verified ------------------------------------------------------------
        setClaimPrintedVerified(claim) {
            this.isLoading = true;
            this.$store
                .dispatch("claims/setPrintedVerified", claim)
                .then(
                    () => {
                        //this.notify("Day Batch successfully saved.", "success");
                    },
                    error => {
                        this.notify(error.response.data, "error");
                        claim.printedVerified = !claim.printedVerified;
                    }
                )
                .finally(this.doneSettingClaimPrintedVerified);
        },
        doneSettingClaimPrintedVerified() {
            this.isLoading = false;
        },
        //cover printed verified ------------------------------------------------------------
        setCoverPrintedVerified() {
            this.isLoading = true;
            this.$store
                .dispatch("dayBatches/setCoverPrintedVerified", {
                    id: this.dayBatch.id,
                    isPrintedVerified: this.dayBatch.coverPrintedVerified
                })
                .then(
                    () => {
                        //this.notify("Day Batch successfully saved.", "success");
                    },
                    error => {
                        this.notify(error.response.data, "error");
                        this.dayBatch.coverPrintedVerified = !this.dayBatch
                            .coverPrintedVerified;
                    }
                )
                .finally(this.doneSettingCoverPrintedVerified);
        },
        doneSettingCoverPrintedVerified() {
            this.isLoading = false;
        },
        //process to daybatch post submission------------------------------------------------------------
        processDayBatch() {
            if (this.validateForm()) {
                this.isLoading = false;
                this.isProcessing = false;
                this.$store
                    .dispatch("dayBatches/setisprocessed", {
                        id: this.dayBatch.id,
                        isProcessed: true
                    })
                    .then(
                        () => {
                            this.notify("Day Batch Processed.", "success");
                            this.emitSavedEntity();
                            this.isLoading = false;
                            this.isProcessing = false;
                            this.closeForm();
                        },
                        error => {
                            this.notify(error.response.data, "error");
                            this.isLoading = false;
                            this.isProcessing = false;
                        }
                    );
            }
        },
        //generate batchfile------------------------------------------------------------
        generateCoverPage() {
            this.isLoading = true;
            this.isGeneratingCoverPage = true;
            this.$store
                .dispatch("dayBatches/generateCoverPage", this.dayBatch.id)
                .then(
                    response => {
                        this.dayBatch.coverFileId = response;
                    },
                    error => this.notify(error.response.data, "error")
                )
                .finally(this.doneGeneratingCoverPage);
        },
        doneGeneratingCoverPage() {
            this.isLoading = false;
            this.isGeneratingCoverPage = false;
        },
        //emitters      ------------------------------------------------------------
        emitSavedEntity(savedDayBatch) {
            this.$emit("saved", savedDayBatch);
        },
        emitDeletedEntity(deletedDayBatch) {
            this.$emit("deleted", deletedDayBatch);
        },
        emitCloseForm() {
            this.$emit("close");
        },
        //general       ------------------------------------------------------------
        notify(message, color) {
            this.notifyShow = true;
            this.notifyMessage = message;
            this.notifyColor = color;
        },
        closeForm() {
            this.notifyShow = false;
            this.emitCloseForm();
        },
        validateForm() {
            this.isValid = this.$refs.dayBatchForm.validate();
            return this.isValid;
        },
        //delete        ------------------------------------------------------------
        deleteEntity() {
            var isConfirmed = confirm(
                "Are you sure you want to delete this Day Batch?"
            );
            if (isConfirmed) {
                this.isLoading = true;
                this.isDeleting = true;
                this.$store
                    .dispatch("dayBatches/delete", this.dayBatch.id)
                    .then(
                        () => {
                            this.notify(
                                "Day Batch successfully deleted.",
                                "success"
                            );
                            this.emitDeletedEntity(this.dayBatch);
                            this.closeForm();
                        },
                        error => this.notify(error.response.data, "error")
                    )
                    .finally(this.deleteEntityDone);
            }
        },
        deleteEntityDone() {
            this.isLoading = false;
            this.isDeleting = false;
        }
    }
};
</script>

<style lang="stylus" scoped></style>